export default "__VITE_ASSET__BbG_Fibl__"